import ProgramTabs from './program-tabs';

export default ProgramTabs;
